var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grouped-row-card" },
    [
      _c("div", { staticClass: "grouped-row-voucher px-3 pt-3 pb-2" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-6 col-md-3" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v("Voucher ID:")
            ]),
            _c("div", { staticClass: "color-black font-weight-bold font-14" }, [
              _vm._v(" " + _vm._s(_vm.value.voucherId || "-") + " ")
            ])
          ]),
          _c("div", { staticClass: "col-6 col-md-3" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v("Fecha de Voucher:")
            ]),
            _c("div", { staticClass: "color-black font-weight-bold font-14" }, [
              _vm.value.voucherDate
                ? _c("span", [
                    _vm._v(_vm._s(_vm._f("date")(_vm.value.voucherDate)))
                  ])
                : _c("span", [_vm._v("-")])
            ])
          ]),
          _c("div", { staticClass: "col-6 col-md-3 mt-2 mt-md-0" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v(" Número de Referencia de Pago: ")
            ]),
            _c("div", { staticClass: "color-black font-weight-bold font-14" }, [
              _vm._v(
                " " + _vm._s(_vm.value.paymentReferenceNumber || "-") + " "
              )
            ])
          ]),
          _c("div", { staticClass: "col-6 col-md-3 mt-2 mt-md-0" }, [
            _c("div", { staticClass: "color-secondary-6 font-14" }, [
              _vm._v("Fecha de Pago:")
            ]),
            _c("div", { staticClass: "color-black font-weight-bold font-14" }, [
              _vm.value.paymentDate
                ? _c("span", [
                    _vm._v(_vm._s(_vm._f("date")(_vm.value.paymentDate)))
                  ])
                : _c("span", [_vm._v("-")])
            ])
          ])
        ])
      ]),
      _c(
        "custom-callout",
        {
          staticClass: "callout__extended grouped-row-callout",
          attrs: { controlled: true, opened: _vm.isOpen },
          on: { "click:open": _vm.onToggleDetails },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _vm.showAddVoucher
                    ? _c("add-payment-voucher", {
                        attrs: {
                          "initial-voucher-date": _vm.value.voucherDate,
                          "initial-voucher-number": _vm.value.voucherId
                        },
                        on: {
                          "on-cancel": _vm.onVoucherCancel,
                          "on-save": _vm.onVoucherSave
                        }
                      })
                    : _vm.showAddPaymentReference
                    ? _c("add-payment-reference", {
                        on: {
                          "on-cancel": _vm.onPaymentReferenceCancel,
                          "on-save": _vm.onPaymentReferenceSave
                        }
                      })
                    : _c("payment-student-services", {
                        attrs: { services: _vm.value.services }
                      })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row mt-3 align-items-center pb-2" }, [
            _c("div", { staticClass: "col-3" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Estudiante:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16" },
                [_vm._v(" " + _vm._s(_vm.value.studentFullName) + " ")]
              )
            ]),
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("SIE:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16" },
                [_vm._v(" " + _vm._s(_vm.value.studentSieId) + " ")]
              )
            ]),
            _c("div", { staticClass: "col mt-3 mt-md-0" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Conteo de Servicios:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16" },
                [_vm._v(" " + _vm._s(_vm.value.serviceCount) + " ")]
              )
            ]),
            _c("div", { staticClass: "col mt-3 mt-md-0" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Costo Total:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("price")(_vm.value.studentTotalAmt)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col mt-3 mt-md-0" }, [
              _c("div", { staticClass: "color-secondary-6 font-14" }, [
                _vm._v("Estatus:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16" },
                [
                  _c("i", {
                    staticClass: "fas fa-circle mr-1",
                    class: `color-${_vm.statusColor}`
                  }),
                  _vm._v(" " + _vm._s(_vm.statusName) + " ")
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "col d-flex justify-content-end mt-3 mt-md-0" },
              [
                _c("drop-down", {
                  attrs: {
                    "data-item": { item: _vm.value, index: _vm.index },
                    items: _vm.actionItems
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }